export let topResults = "fQMVRc";
export let allResults = "xDqb0b";
export let recentResults = "pseX6d";
export let queryOnTypeRecent = "Cqduob";
export let moreResults = "fQB0mb";
export let queryOnTypeMore = "y9Pone";
export let pinned = "Oy$hOd";
export default {topResults,allResults,recentResults,queryOnTypeRecent,moreResults,queryOnTypeMore,pinned};